<h1 mat-dialog-title>
    Les scopes sélectionnés donnent les droits suivants au bot :
</h1>
<div mat-dialog-content>
    <div *ngIf="dataCount === 0">
        Aucun droit
    </div>
    <div *ngIf="dataCount > 0">
        <mat-table #table [dataSource]="dataSource">
            <!--ID-->
            <ng-container matColumnDef="id">
                <mat-header-cell *matHeaderCellDef>
                    Droit
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{ element.id }}
                </mat-cell>
            </ng-container>

            <!--READ-->
            <ng-container matColumnDef="READ">
                <mat-header-cell *matHeaderCellDef>
                    Lecture seule
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <mat-icon [class]="'material-icons mat-icon ' + (element.read ? 'syn-text--success' : 'syn-text--muted')" [svgIcon]="element.read ? 'check' : 'close'">
                    </mat-icon>
                </mat-cell>
            </ng-container>

            <!--EDIT-->
            <ng-container matColumnDef="EDIT">
                <mat-header-cell *matHeaderCellDef>
                    Lecture/écriture
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <mat-icon [class]="'material-icons mat-icon ' + (element.edit ? 'syn-text--success' : 'syn-text--muted')" [svgIcon]="element.edit ? 'check' : 'close'">
                    </mat-icon>
                </mat-cell>
            </ng-container>

            <!--ADMIN-->
            <ng-container matColumnDef="ADMIN">
                <mat-header-cell *matHeaderCellDef>
                    Administration
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <mat-icon [class]="'material-icons mat-icon ' + (element.admin ? 'syn-text--success' : 'syn-text--muted')" [svgIcon]="element.admin ? 'check' : 'close'">
                    </mat-icon>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Fermer</button>
</div>
